import { type Routes } from '@angular/router';

import { authGuard, guestGuard, permissionGuard } from '@core/guards';

export const routes: Routes = [
  {
    path: 'auth',
    canMatch: [guestGuard],
    loadComponent: () => import('@layouts/auth-layout').then((layout) => layout.AuthLayout),
    loadChildren: () => import('./auth-routes').then((routes) => routes.AUTH_ROUTES),
  },

  {
    path: '',
    canMatch: [authGuard],
    loadComponent: () => import('@layouts/default-layout').then((layout) => layout.DefaultLayout),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },

      {
        path: 'dashboard',
        data: {
          titleKey: 'pages.dashboard.title',
        },
        loadComponent: () => import('@pages/dashboard').then((m) => m.DashboardPage),
      },

      {
        path: 'ai-daily-brief',
        data: {
          titleKey: 'pages.aiDailyBrief.title',
        },
        loadComponent: () => import('@pages/ai-daily-brief').then((m) => m.AiDailyBriefPage),
      },

      {
        path: 'firms',
        data: {
          titleKey: 'pages.firms.title',
        },
        canMatch: [permissionGuard('view_firms')],
        loadComponent: () => import('@pages/firms').then((m) => m.FirmsPage),
      },

      {
        path: 'users',
        data: {
          titleKey: 'pages.users.title',
        },
        canMatch: [permissionGuard('view_users')],
        loadChildren: () => import('./users-routes').then((routes) => routes.USERS_ROUTES),
      },

      {
        path: 'matters',
        data: {
          titleKey: 'pages.matters.title',
        },
        canMatch: [permissionGuard('view_matters')],
        loadChildren: () => import('./matters-routes').then((routes) => routes.MATTERS_ROUTES),
      },

      {
        path: 'documents',
        data: {
          titleKey: 'pages.documents.title',
        },
        loadComponent: () => import('@pages/documents').then((m) => m.DocumentsPage),
      },

      {
        path: 'findings-register',
        data: {
          titleKey: 'pages.findingsRegister.title',
        },
        loadComponent: () => import('@pages/findings-register').then((m) => m.FindingsRegisterPage),
      },

      {
        path: 'notifications',
        data: {
          titleKey: 'pages.notifications.title',
        },
        loadComponent: () => import('@pages/notifications').then((m) => m.NotificationsPage),
      },

      {
        path: 'settings',
        data: {
          titleKey: 'pages.settings.title',
        },
        loadChildren: () => import('./settings-routes').then((routes) => routes.SETTINGS_ROUTES),
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
